import { render, staticRenderFns } from "./AiAssistantAgent.vue?vue&type=template&id=376a8ff8&scoped=true&"
import script from "./AiAssistantAgent.vue?vue&type=script&lang=js&"
export * from "./AiAssistantAgent.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantAgent.vue?vue&type=style&index=0&id=376a8ff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a8ff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376a8ff8')) {
      api.createRecord('376a8ff8', component.options)
    } else {
      api.reload('376a8ff8', component.options)
    }
    module.hot.accept("./AiAssistantAgent.vue?vue&type=template&id=376a8ff8&scoped=true&", function () {
      api.rerender('376a8ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantAgent.vue"
export default component.exports